import React, { useState, useEffect } from "react";

// DATA
import { DataContactOne } from "../data/DataContact";

function SideBar() {
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  const handleCloseMenu = () => {
    setIsMenuVisible(false);
  };

  return (
    <div>
      <div id="side-hide" className={isMenuVisible ? "show" : ""}>
        <div className="top-area">
          <a
            href="/"
            className="logo-area wow pulse"
            data-wow-iteration="infinite"
            data-wow-duration="2s"
          >
            <img src="assets/images/logo/logo-03.png" alt="logo" />
          </a>
          <div className="close-icon-area">
            <div id="close-slide__main">
              <i className="fa-solid fa-x" />
            </div>
          </div>
        </div>
        <div className="body">
          <h5 className="title">{DataContactOne.desc2}</h5>
          <p className="disc">{DataContactOne.desc}</p>
          <div className="short-contact-area-side-collups">
            {/* single contact information */}
            <div className="single-contact-information-side">
              <i className="fa-solid fa-phone" />
              <div className="information">
                <span>Téléphone</span>
                <a href="#" className="number">
                  {DataContactOne.phone}
                </a>
                <br />
                <a href="#" className="number">
                  {DataContactOne.phone2}
                </a>
              </div>
            </div>
            {/* single contact information end */}
            {/* single contact information */}
            <div className="single-contact-information-side">
              <i className="fa-light fa-envelope" />
              <div className="information">
                <span>E-mail</span>
                <a href="#" className="number">
                  {DataContactOne.email}
                </a>
              </div>
            </div>
            {/* single contact information end */}
            {/* single contact information */}
            <div className="single-contact-information-side">
              <i className="fa-sharp fa-light fa-location-dot" />
              <div className="information">
                <span>Siège</span>
                <a href="#" className="number">
                  {DataContactOne.address}
                </a>
              </div>
            </div>
            {/* single contact information end */}
          </div>
          {/* social area start */}
          <ul className="social-icons solid-social-icons rounded-social-icons">
            {DataContactOne?.mediaLinks.map((item) => {
              if (item.name === "facebook") {
                return (
                  <li key={item.id}>
                    <a href="#">
                      <i className={`fa-brands fa-${item.name}-f`} />
                    </a>
                  </li>
                );
              } else {
                return (
                  <li key={item.id}>
                    <a href="#">
                      <i className={`fa-brands fa-${item.name}`} />
                    </a>
                  </li>
                );
              }
            })}
          </ul>
          {/* social area end */}
        </div>
        {/* mobile menu area start */}
        <div className="mobile-menu-main">
          <nav className="nav-main mainmenu  mainmenu-nav mt--30">
            <ul>
              <li>
                <a className="nav-link" href="#home">
                  HOME
                </a>
              </li>
              <li>
                <a className="nav-link" href="#about">
                  ABOUT
                </a>
              </li>
              <li>
                <a className="nav-link" href="#service">
                  SERVICES
                </a>
              </li>
              <li>
                <a className="nav-link" href="#product">
                  PORTFOLIO
                </a>
              </li>
              <li>
                <a className="nav-link" href="#blog">
                  BLOG
                </a>
              </li>
              <li>
                <a className="nav-link" href="#contactus">
                  CONTACT
                </a>
              </li>
            </ul>
          </nav>
        </div>
        {/* mobile menu area end */}
      </div>
    </div>
  );
}

export default SideBar;
